module.exports = __webpack_public_path__ + "img/admin-img.c9ae2a02.png";